import {
  getPriceForCountry,
  getSelectedCountry,
} from "../../functions/CountryFunctions";
import { colorOptions } from "../../constants";
import { useNavigate } from "react-router-dom";
import { getProductCardValueLine } from "../../utils/productValueUtils";
import "./Shop.css";

const GridContent = ({ product, onBeforeNavigate, grid }) => {
  const selectedCountry = getSelectedCountry();
  const { price, symbol } = getPriceForCountry(product.prices, selectedCountry);

  const maxVisibleColours = 4;
  const visibleColours = product.colors?.slice(0, maxVisibleColours) || [];
  const remainingColours = Math.max(
    (product.colors?.length || 0) - maxVisibleColours,
    0,
  );

  console.log(product);

  const navigate = useNavigate();
  const handleClick = () => {
    if (onBeforeNavigate) {
      onBeforeNavigate();
    }
    navigate(`/shop/${product.id}`);
  };

  const isLimitedEdition = Array.isArray(product.collections)
    ? product.collections.includes("Limited Edition")
    : product.collection === "Limited Edition";

  return (
    <div
      key={product.id}
      className="shop_list-item"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") handleClick();
      }}
    >
      {isLimitedEdition && (
        <div className="shop_list-item__badge">Limited Edition</div>
      )}
      <img
        src={product.variants?.[0]?.imageURLs?.[0]}
        alt={`Main image of ${product.title}`}
        loading="lazy"
      />

      <div className="shop_list-item__content">
        <div>
          <h1 className="shop_list-item__title">{product.title}</h1>

          {grid && (
            <p className="shop_list-item__tagline">
              {product?.tagline}
            </p>
          )}
        </div>

        <p className="shop_list-item__description">
          {getProductCardValueLine(product.category)}
        </p>

        <p className="shop_list-item__price">
          {symbol}
          {price}
        </p>

        {!!visibleColours.length && (
          <div className="shop_list-item__colors">
            {visibleColours.map((color, idx) => {
              const hex = colorOptions[color] || color;
              const normalizedHex = String(hex).toLowerCase();
              const isLight = ["#fff", "#ffffff", "white"].includes(
                normalizedHex,
              );

              return (
                <span
                  key={`${color}-${idx}`}
                  className={`shop_list-item__color-swatch ${
                    isLight ? "shop_list-item__color-swatch--light" : ""
                  }`}
                  style={{ background: hex }}
                  aria-label={color}
                  title={color}
                />
              );
            })}

            {remainingColours > 0 && (
              <span className="shop_list-item__remaining-colors">
                +{remainingColours}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default GridContent;
